import { X } from 'lucide-react';
import { Badge } from '@avanta/shared/components/ui/Badge';
import { Button } from '@avanta/shared/components/ui/Button';

interface AttachmentListProps {
  files: File[];
  onRemove: (lastModified: number) => void;
}

export const AttachmentList = ({ files, onRemove }: AttachmentListProps): React.ReactElement => (
  <div className="flex items-center gap-2 flex-wrap">
    {files.map(file => (
      <Badge
        key={`${file.name}-${file.lastModified}`}
        size="sm"
        className="cursor-pointer rounded-sm bg-white text-denim-600 border border-plum-200 h-8"
      >
        {file.name}
        <Button
          variant="ghost"
          type="button"
          className="p-0 size-6 hover:text-red-500 hover:bg-transparent"
          onClick={() => onRemove(file.lastModified)}
        >
          <X />
        </Button>
      </Badge>
    ))}
  </div>
);
